(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-layout-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function loadScript(src){
    return new Promise(function(resolve, reject){
      if (document.querySelector('script[src="'+src+'"]')) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function loadCSS(href){
    return new Promise(function(resolve, reject){
      if (document.querySelector('link[href="'+href+'"]')) return resolve();
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = resolve;
      l.onerror = reject;
      document.head.appendChild(l);
    });
  }

  function initTestimonials(){
    var $owl = jQuery('.testimonials-wrapper');
    if (!$owl.length) return;

    // Add class if missing
    if (!$owl.hasClass('owl-carousel')) $owl.addClass('owl-carousel');

    $owl.owlCarousel({
      items: 2,
      margin: 20,
      loop: true,
      dots: true,
      responsive: {0:{items:1, dots: false},768:{items:2},1024:{items:2}}
    });

    // Outside navigation
    jQuery('.owl-next').click(function(){ $owl.trigger('next.owl.carousel'); });
    jQuery('.owl-prev').click(function(){ $owl.trigger('prev.owl.carousel'); });

    // Read More / Read Less
    const maxWords = 16;
    const readMoreText = "Read More +";
    const readLessText = "Read Less";

    $owl.find('.testimonial-card').each(function(){
      var $txt = jQuery(this).find('.testimonial-text');
      var fullText = $txt.text().trim();
      var wordsArray = fullText.split(/\s+/);
      if(wordsArray.length <= maxWords) return;

      $txt.text(wordsArray.slice(0,maxWords).join(' ') + "...");
      var $link = jQuery('<a href="#" class="read-more-link">'+readMoreText+'</a>');
      $txt.after($link);

      $link.click(function(e){
        e.preventDefault();
        if($txt.hasClass('expanded')){
          $txt.text(wordsArray.slice(0,maxWords).join(' ') + "...");
          $txt.removeClass('expanded');
          $link.text(readMoreText);
        } else {
          $txt.text(fullText);
          $txt.addClass('expanded');
          $link.text(readLessText);
        }
      });
    });
  }

  // Load jQuery + Owl Carousel + CSS sequentially
  Promise.resolve()
    .then(function(){
      if(typeof jQuery === 'undefined') return loadScript('https://code.jquery.com/jquery-3.6.0.min.js');
    })
    .then(function(){
      return Promise.all([
        loadCSS('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.carousel.min.css'),
        loadCSS('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.theme.default.min.css'),
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js')
      ]);
    })
    .then(initTestimonials)
    .catch(function(err){ console.error('Testimonials failed to load:', err); });

})();

  } catch(e) { console.error(e); }
})();
})();
